/** API may send 0/1, "0"/"1", or booleans. */
export function allowsModifierMultiSelect(g) {
  const v = g?.allow_multiple_selection;
  if (v === true || v === 1) return true;
  if (typeof v === 'string') {
    const s = v.trim().toLowerCase();
    return s === '1' || s === 'true' || s === 'yes';
  }
  return Number(v) === 1;
}

export function getGroupMinSel(g, isRequired) {
  const fromField = Number(g?.modifier_min_selection);
  if (Number.isFinite(fromField) && fromField > 0) return fromField;
  return isRequired ? 1 : 0;
}

export function getGroupMaxSel(g) {
  const m = Number(g?.modifier_max_selection);
  return Number.isFinite(m) && m > 0 ? m : 0;
}

export function isQuantitativeGroup(g) {
  const t = String(g?.modifier_type ?? g?.type ?? '').toLowerCase();
  return t === 'quantitative';
}

/** Multiple *distinct* options (checkbox list). Max 1 distinct → radio UI. */
export function pickMultipleDistinctOptions(g) {
  if (!allowsModifierMultiSelect(g)) return false;
  const cap = getGroupMaxSel(g);
  return cap === 0 || cap > 1;
}

export function optionQtyBounds(o) {
  const rawMin = Number(o?.min ?? o?.min_quantity ?? o?.modifier_option_min);
  const min = Number.isFinite(rawMin) ? Math.max(0, rawMin) : 0;
  const rawMax = Number(o?.max ?? o?.max_quantity ?? o?.modifier_option_max);
  const max = Number.isFinite(rawMax) && rawMax >= 1 ? rawMax : 1;
  return { min, max };
}

/**
 * Group min/max apply to the sum of all option quantities in the group.
 * True when multi-select has modifier_max_selection (shared pool, e.g. sauces total ≤ 3),
 * or for quantitative groups that are not unlimited multi-checkbox.
 */
export function groupLimitsUseTotalSum(g) {
  if (allowsModifierMultiSelect(g) && getGroupMaxSel(g) > 0) {
    return true;
  }
  return isQuantitativeGroup(g) && !pickMultipleDistinctOptions(g);
}

export function optionAllowsStacking(o) {
  return optionQtyBounds(o).max > 1;
}
